import actions from './actions';
import mutations from './mutations';
import getters from "./getters";

const productImport = {
    namespaced: true,
    state: {
        file: null,
        uploadInProgress: false,
        importInProgress: false,
        validationResults: {},
        target: {
            brandId: null,
            establishmentId: null,
            establishmentAddressId: null
        }
    },
    mutations,
    actions,
    getters
};

export default productImport;
